var viewer_caption_rtlignore_default = {
  "fontElementMap": "cikeC",
  "imageCaption": "wAHjy"
};
export {
  viewer_caption_rtlignore_default as default
};
//# sourceMappingURL=viewer-caption.rtlignore-scss.js.map
